import api from './api';
import { API_ENDPOINTS, USE_MOCK_DATA } from '../constants/config';
import { getMockCompanies } from '../data/mockData';
import siteService from './siteService';
import { ROLES } from '../constants/roles';

// Temporary mock data for SPOCs
let mockSpocs = [
  {
    id: 1,
    name: 'David Wilson',
    email: 'david.w@clientcorp.com',
    contact: '9876543211',
    company_id: 1,
    company: { company_name: 'TechCorp Industries' },
    site_ids: [1], 
    sites: [{ id: 1, name: 'HQ Building' }], 
    team_lead: { name: 'Sarah Jenkins' },
    active_tickets: 3,
    is_locked_out: false
  }
];

class SpocService {
  async getAllSpocs() {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ success: true, data: mockSpocs });
        }, 300);
      });
    }

    try {
      const response = await api.get(API_ENDPOINTS.USERS_BY_ROLE(ROLES.CUSTOMER));
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching SPOCs:', error);
      return { success: false, error: error.message };
    }
  }

  async createSpoc(spocData) {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const companyId = Number(spocData.company_id);
          const siteIds = Array.isArray(spocData.site_ids) ? spocData.site_ids.map(Number) : [];

          const companies = getMockCompanies();
          const selectedCompany = companies.find((company) => company.id === companyId);

          const sitesResult = await siteService.getAllSites();
          const selectedSites = sitesResult.success
            ? sitesResult.data.filter((site) => siteIds.includes(site.id))
            : [];

          const newSpoc = {
            id: mockSpocs.length + 100,
            ...spocData,
            company_id: companyId,
            site_ids: siteIds,
            company_name: selectedCompany?.company_name || 'Unassigned',
            company: { company_name: selectedCompany?.company_name || 'Unassigned' },
            sites: selectedSites,
            team_lead: { name: spocData.team_lead_name || 'Not Assigned' },
            role: ROLES.CUSTOMER,
            active_tickets: 0,
            is_locked_out: false
          };
          mockSpocs.unshift(newSpoc);
          resolve({ success: true, data: newSpoc });
        }, 500);
      });
    }

    try {
      const response = await api.post(API_ENDPOINTS.USERS, { ...spocData, role: ROLES.CUSTOMER });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating SPOC:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }

  async updateSpoc(spocId, spocData) {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          const spocIndex = mockSpocs.findIndex(s => s.id === spocId);
          if (spocIndex !== -1) {
            const companyId = Number(spocData.company_id);
            const siteIds = Array.isArray(spocData.site_ids) ? spocData.site_ids.map(Number) : mockSpocs[spocIndex].site_ids;

            const companies = getMockCompanies();
            const selectedCompany = companies.find((company) => company.id === companyId);

            const sitesResult = await siteService.getAllSites();
            const selectedSites = sitesResult.success
              ? sitesResult.data.filter((site) => siteIds.includes(site.id))
              : mockSpocs[spocIndex].sites;

            mockSpocs[spocIndex] = {
              ...mockSpocs[spocIndex],
              ...spocData,
              company_id: Number.isNaN(companyId) ? mockSpocs[spocIndex].company_id : companyId,
              site_ids: siteIds,
              company_name: selectedCompany?.company_name || mockSpocs[spocIndex].company_name || 'Unassigned',
              company: { company_name: selectedCompany?.company_name || mockSpocs[spocIndex].company_name || 'Unassigned' },
              sites: selectedSites,
              team_lead: {
                name: spocData.team_lead_name ||
                  mockSpocs[spocIndex].team_lead?.name ||
                  mockSpocs[spocIndex].team_lead ||
                  'Not Assigned'
              }
            };
            resolve({ success: true, data: mockSpocs[spocIndex] });
          } else {
            resolve({ success: false, error: 'SPOC not found' });
          }
        }, 500);
      });
    }

    try {
      const response = await api.put(API_ENDPOINTS.USER_DETAILS(spocId), spocData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating SPOC:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }

  async deleteSpoc(spocId) {
    if (USE_MOCK_DATA) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const spocIndex = mockSpocs.findIndex(s => s.id === spocId);
          if (spocIndex !== -1) {
            const spoc = mockSpocs[spocIndex];
            if (spoc.active_tickets > 0) {
              resolve({ 
                success: false, 
                error: `Cannot delete SPOC with ${spoc.active_tickets} active ticket(s).` 
              });
            } else {
              mockSpocs.splice(spocIndex, 1);
              resolve({ success: true });
            }
          } else {
            resolve({ success: false, error: 'SPOC not found' });
          }
        }, 500);
      });
    }

    try {
      await api.delete(API_ENDPOINTS.USER_DETAILS(spocId));
      return { success: true };
    } catch (error) {
      console.error('Error deleting SPOC:', error);
      return { success: false, error: error.response?.data?.detail || error.message };
    }
  }
}

export default new SpocService();